(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/betslip-confirm-campaign.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/betslip-confirm-campaign.js');

'use strict';

const {
  locationConfirmedAtom,
  pinLocationTypeAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const {
  useAtomValue,
  useSetAtom
} = jotai;
const Button = svs.ui.ReactButton;
const BetslipConfirmCampaign = () => {
  const setLocationConfirmed = useSetAtom(locationConfirmedAtom);
  const pinLocationType = useAtomValue(pinLocationTypeAtom);
  const handleClick = () => {
    svs.components.analytics.trackEvent({
      category: 'Lyckoplatsen',
      action: 'Spela här',
      opt_label: pinLocationType
    });
    setLocationConfirmed(true);
  };
  return React.createElement("div", {
    className: "lp-betslip-confirm"
  }, React.createElement("img", {
    className: "campaign-image",
    src: "".concat(svs.core.config.data.svsconfig.cdn, "/images/lyckoplatsen/triss.png"),
    alt: "Triss kampanj"
  }), React.createElement(Button, {
    block: true,
    size: "500",
    className: "lp-green",
    onClick: handleClick
  }, "Spela h\xE4r"));
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  BetslipConfirmCampaign
});

 })(window);